"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Cart = void 0;
var _reactMintl = require("@godaddy/react-mintl");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _link = _interopRequireDefault(require("@ux/link"));
var _cart = _interopRequireDefault(require("@ux/icon/cart"));
var _classnames = _interopRequireDefault(require("classnames"));
var _addhoc = _interopRequireDefault(require("addhoc"));
var _componentUtilities = require("@ux/component-utilities");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large'];
/**
 * Render the checkout link with optional text.
 *
 * @Constructor
 * @class Cart
 * @public
 */
class Cart extends _react.Component {
  state = {
    items: null
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.items !== nextProps.items) {
      return {
        items: nextProps.items
      };
    }
    return null;
  }

  /**
   * Render the cart icon.
   * Only show the icon (no message) if mobile.
   *
   * @returns {React.ReactElement} Translated cart icon and optional message.
   * @api private
   */
  render() {
    const props = this.props;
    const items = typeof this.state.items === 'number' ? this.state.items : props.items;
    const messageId = items ? 'Shared:UtilityBar:Cart:ItemsInCartMessage' : 'Shared:UtilityBar:Cart:EmptyCartMessage';
    const icon = /*#__PURE__*/_react.default.createElement("span", {
      style: {
        display: 'flex'
      },
      "aria-label": props.messages[messageId],
      className: (0, _classnames.default)('cart-icon', {
        'cart-empty': !items
      })
    }, /*#__PURE__*/_react.default.createElement(_cart.default, {
      width: 30,
      height: 30
    }));

    // Show nothing when showEmpty is false and there are no items.
    if (!props.showEmpty && !items) {
      return null;
    }

    // Return icon when iconOnly is true.
    if (props.iconOnly) {
      return icon;
    }

    // Show just the icon if the cart is empty or if we're in mobile

    if (props.showEmpty && !items || (0, _componentUtilities.isMobile)(props.breakpoint) || props.hideCheckoutNow) {
      return /*#__PURE__*/_react.default.createElement(_link.default, {
        "aria-label": props.messages[messageId],
        urlArgs: props.urlArgs,
        href: props.checkout,
        "data-eid": props.eid,
        className: props.className
      }, icon);
    }

    // In non-mobile when the cart has items, and hideCheckoutNow is false, show the full "Checkout Now" link

    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      urlArgs: props.urlArgs,
      href: props.checkout,
      "data-eid": props.eid,
      className: props.className
    }, icon, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: messageId,
      className: "checkout-now-text"
    })));
  }
}

/**
 * Helper to update cart items, needs to be bound to proper scope that has state
 * on the number of items before the function can be used.
 *
 * @param {number} items Updated cart count.
 * @param {function} done Optional completion callback.
 * @public
 */
exports.Cart = Cart;
Cart.update = function update(items) {
  let done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  // @ts-ignore
  this.setState({
    // @ts-ignore
    items: parseInt(items, 10) || 0
  }, done);
};

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Cart.defaultProps = {
  eid: 'uxp.hyd.app_header.header.cart.cart_link.link.click',
  market: 'en',
  items: 0,
  showEmpty: false,
  iconOnly: false
};

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Cart.propTypes = {
  /** current breakpoint */
  breakpoint: _propTypes.default.string,
  /** eid to be used on link click events */
  eid: _propTypes.default.string,
  /** Item count representing how many items are in the cart */
  items: _propTypes.default.number,
  /** If the customer is logged in */
  loggedIn: _propTypes.default.bool,
  /** Market needed for IntlProvider  */
  market: _propTypes.default.string,
  /** Checkout url for the cart */
  checkout: _propTypes.default.string.isRequired,
  /** Messages for IntlProvider */
  messages: _propTypes.default.object.isRequired,
  /** Show the empty cart icon, default false */
  showEmpty: _propTypes.default.bool,
  /** Render the icon only, no link, default false */
  iconOnly: _propTypes.default.bool,
  /** Additional info for like component  */
  urlArgs: _propTypes.default.object,
  /** Display additional checkout now text next to cart */
  hideCheckoutNow: _propTypes.default.bool,
  /** Custom classnames  */
  className: _propTypes.default.string
};
const withBreakpoints = (0, _addhoc.default)(getWrappedComponent => {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(...breakpoints);
  return getWrappedComponent({
    breakpoint
  });
}, 'WithBreakpoints');
var _default = withBreakpoints(Cart);
exports.default = _default;